module.exports = __webpack_public_path__ + "img/de.076cbd5a.png";